import React, { useState } from "react";
import CustomBadges from "./CustomBadges";
import Notification from "./Notification";
import a2Logo from "../assets/images/image 4.png";
import {
  CheckBadgeIcon,
  CheckCircleIcon,
  MapPinIcon,
} from "@heroicons/react/24/outline";
import CustomTooltip from "./Filters/CustomTooltip";
import DocumentTypeIcons from "./Filters/CustomDocumentTypeIcons";
import { useNavigate } from "react-router-dom";

const ProviderCard = ({
  type,
  services,
  city,
  country,
  rfi,
  assessment,
  badgeColor,
  imageUrl,
  name,
  documentType,
  id,
  address1,
}) => {
  const [show, setShow] = useState(false);
  const providerNameTrim = name?.length > 50 ? name.slice(0, 30) + "..." : name;
  const navigate = useNavigate();

  return (
    <div
      className="w-72 rounded-2xl bg-white border h-height-21-rem cursor-pointer"
      onClick={() => navigate(`/provider/${id}/overview`)}
    >
      <div
        className={` w-full h-20 rounded-t-2xl flex justify-center bg-gray-50 ${
          imageUrl ? "" : "items-center"
        }`}
      >
        {imageUrl ? (
          <img
            src={imageUrl}
            alt="Card Image"
            className="w-40 h-16 object-contain pt-2.5"
            title={name}
            loading="lazy"
          />
        ) : (
          <div className="text-custom-light-grey  font-semibold text-center">
            <CustomTooltip sliceLength={50} cutOffAfter={30}>
              {name}
            </CustomTooltip>
          </div>
        )}
      </div>

      <div className="px-4 pb-3 flex flex-col divide-y divide-gray-100">
        <div className="py-2">
          <div className="flex items-center justify-between">
            <dt className="text-sm font-semibold text-custom-dark-grey mr-2">
              Type
            </dt>
            <dd className="text-custom-dark-grey text-sm">{type}</dd>
          </div>
        </div>

        <div className="pt-1">
          <div className="w-full text-sm font-semibold text-custom-dark-grey">
            Services
          </div>
          <div className="flex items-start flex-wrap py-2 h-20">
            <CustomBadges
              services={services}
              isProviderDetail={false}
              icon={true}
            />
          </div>
        </div>

        <div className="flex justify-between items-center py-2 flex-1">
          {/* <dt className="text-sm font-semibold text-custom-dark-grey">
            Location
          </dt> */}
          <div className="flex justify-end items-center text-custom-link-color font-normal text-end text-sm space-x-1">
            <MapPinIcon
              width={22}
              height={22}
              className="text-custom-link-bg-color"
            />

            <span>
              <CustomTooltip cutOffAfter={30} sliceLength={30}>
                {`${address1}${city !== null ? "," : ""} ${
                  city !== null ? city : ""
                }${city !== null && country !== null ? ", " : ""} ${
                  country !== null ? country : ""
                }`}
              </CustomTooltip>
            </span>
          </div>
        </div>

        <div className="flex justify-between items-start py-2 flex-1">
          {/* <dt className="text-sm font-semibold text-custom-dark-grey">
            Documents
          </dt> */}
          <div>
            <dd className="text-custom-dark-grey font-normal text-end text-sm flex items-center">
              <CheckCircleIcon
                width={22}
                height={22}
                className="mr-2 text-indigo-700"
              />
              {rfi} RFIs
            </dd>
            <dd className="text-custom-dark-grey font-normal text-end text-sm flex items-center">
              <CheckBadgeIcon
                width={22}
                height={22}
                className="mr-2 text-rose-700"
              />
              {assessment} Assessments
            </dd>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProviderCard;
